<template>
    <section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
            </p>
        </div>

        <div class="bar-container-inspections">
            <div class="bar-container-inspections__search-bar">
                <div class="input-field my-0" v-if="daily_assignments.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container-inspections__options">
                <label v-html="`See all rooms`" class="modal-label mb-1" style="display: block; font-size: 13px; color: #212529;"/>
                <div class="custom-control custom-checkbox">
                    <input 
                        type="checkbox" 
                        class="custom-control-input"
                        v-model="see_all_rooms"
                        id="see_all_rooms"
                    />
                    <label
                        class="custom-control-label ml-1"
                        for="see_all_rooms"
                    />
                </div>
            </div>
            <div class="bar-container-inspections__cta">
                <button class="modal__buttons__item w-auto ml-1 ml-md-2 px-3" v-html="`Close`" @click="backToReports()" style="margin-right:8px; float: right;"/>
                <span class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2">
                    <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="'Export'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                        <span class="sr-only"/>
                    </button>
                    <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                        <a class="dropdown-item" href="#" v-html="'Export to PDF Portrait'" @click="exportPDF('portrait')"/>
                        <a class="dropdown-item" href="#" v-html="'Export to PDF Landscape'" @click="exportPDF('landscape')"/>
                    </div>
                </span>
            </div>
        </div>
        
        <div class="tab-content" v-for="(item, index) in  daily_assignments" :key="index">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <h6 class="mb-4"  v-html="`${item.daily_assignment.number_assigment} - ${item.daily_assignment.description}`" v-if="daily_assignments.length > 1"/>
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="item.rooms_assigned"
                                :search="search"
                                :checkable="false"
                                :link="'#'"
                                :selectable_columns="false"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <WaitingModal/>
    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>

</template>

<script>
import axios        from 'axios';
import Resources    from './resources'
import Breadcrumb   from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import DinamicTable from '@/components/DinamicTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import jsPDF        from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Notyf }    from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css' // for React and Vue
// import FormResources from './form_resources';
const notyf = new Notyf({
    duration: 8000,
});



export default {

    name: "QuickReportAbbreviated",

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTable,
        UnauthorizedComponent,
    },

    data() {
        return {
            notyf,
            axios,
            report_root:        {},
            parent_id:           3,
            daily_assignment_id: this.$route.params.id,
            user:               this.get_user(),
            title_page:         'Reports',
            rest_api:           `search_standard_reports`,
            current_url:        `/reports`,
            table_headers:      [],
            breadcrumb:         JSON.parse(JSON.stringify(Resources.breadcrumb)),
            search:             '',
            global_index:       '',

            json_excel_fields:  {},
            json_pdf_fields:    Resources.quick_report_abbreviated_view,

            company_name: 'Digital Solutions, SE & Associates, Inc.',

            headers_break_table:    Resources.headers_break_table_abbreviated,
            headers_step_codes_table: Resources.headers_step_codes_table,
            today:                  new Date(),
            logo_corporation:  null,
            daily_assignments:      [],
            see_all_rooms: false
        };
    },

    methods: {

        backToReports()
        {
            window.location.href = '/reports'
        },

        addWaterMark(doc)
        {
            return doc
        },

        createRows(count) {
            const rows = [];
            for (let i = 1; i <= count; i++) {
                rows.push([i, `Name ${i}`, `Email ${i}`])
            }
            return rows;
        },

        exportPDF(orientation)
        {   
            
            const doc = new jsPDF(orientation , 'pt', 'letter');

            // const doc = new jsPDF('p', 'pt', 'a4');

            // overall margin
            const margin = {
                left: 11,
                right: 11,
                top: 4,
                bottom: 4,
            };

            // const rowsCount = 245

            // number of table sections in the page
            const sections = 3

            // space between each section
            const spacing = 11;

            // calculate each section width
            const printWidht = doc.internal.pageSize.width- (margin.left + margin.right);
            const sectionWidth = (printWidht - ((sections - 1) * spacing)) / sections;

            // add an initial empty page that will be delete later,
            // it is needed for the first setPage(previous_page) call
            doc.addPage();

            this.daily_assignments.forEach((item, index) => 
            {
                let start_height = 135;

                if(index > 0)
                {
                    doc.addPage()
                    let total_page = doc.internal.getNumberOfPages()
                    doc.setPage(total_page)
                    start_height = 92;
                }
                else
                {
                    autoTable(doc, {
                    columns: [this.report_root.name], 
                    body: [],
                    tableWidth: sectionWidth,
                    startY: 60,
                    margin,
                    rowPageBreak: 'avoid',
                    styles: {fontSize: 10},
                    headStyles:{
                        valign: 'middle',
                        halign : 'center',
                        fillColor : [245, 245, 245],
                        textColor: [70, 70, 71],
                        fontStyle: 'normal',
                    }})
                }
                

                doc.setTextColor(150)
                doc.setFontSize(8);
                // doc.text(this.report_root.full_date, start_height - 40, 13)

                doc.addImage("/assets/img/logo.png", 'png', 10, 24, 80, 18)

                if(this.logo_corporation)
                {
                    doc.addImage(this.logo_corporation.base64, 110, 10, this.logo_corporation.width * .8, this.logo_corporation.height * .6);
                }

               

                doc.setFontSize(12)
                doc.setTextColor(70)

                // doc.text(15, 75, this.report_root.name)    

                doc.setFontSize(8)

                doc.setFont(undefined, 'bold')

                doc.text(7, start_height - 40, 'ASSIGNMENT:')
                doc.text(7, start_height - 27, 'DAY:')
                doc.text(7, start_height - 14, 'ASSOCIATE PAGER:')
                doc.text(7, start_height - 1, 'SUPERVISOR PAGER:')
                doc.text(7, start_height + 12, 'LAST MODIFIED DATE:')
                doc.text(7, start_height + 28, `* (asterisk) indicates a room assigned for today only`)
                
                doc.setFont(undefined, 'normal')

                doc.text(64, start_height - 40, `${item.daily_assignment.number_assigment} - ${item.daily_assignment.description}`, {
                    maxWidth: 130,
                }).setFont(undefined, 'normal')
                doc.text(30, start_height - 27, this.report_root.day_of_today)
                doc.text(89, start_height - 14, `${(item.daily_assignment.associate_pager) ? item.daily_assignment.associate_pager : ''}`)
                doc.text(94, start_height - 1, `${(item.daily_assignment.supervisor_pager) ? item.daily_assignment.supervisor_pager : ''}`)
                doc.text(98, start_height + 12, `${item.last_modified_date}`)
                

                autoTable(doc, {
                    columns: this.headers_break_table, 
                    body: item.breaks, 
                    tableWidth: sectionWidth,
                    startY: start_height + 38,
                    margin,
                    rowPageBreak: 'avoid',
                    styles: {fontSize: 8},
                })


                autoTable(doc, {
                    columns: this.json_pdf_fields,
                    body: item.rooms_assigned,
                    tableWidth: sectionWidth,
                    margin,
                    rowPageBreak: 'avoid', // avoid breaking rows into multiple sections
                    showHead: 'never',
                    drawRow: function (row) 
                    {
                        row.height = 5
                    },
                    styles: {fontSize: 8},
                    didDrawPage({table, pageNumber}) 
                    {
                        const docPage = doc.internal.getNumberOfPages();
                        const nextShouldWrap = pageNumber % sections;

                        if (nextShouldWrap) {
                            // move to previous page, so when autoTable calls
                            // addPage() it will still be the same current page
                            doc.setPage(docPage - 1);

                            // change left margin which will controll x position
                            table.settings.margin.left += sectionWidth + spacing;
                        } else {
                            // reset left margin for the first section in every page
                            table.settings.margin.left = margin.left;
                        }
                    },
                    didParseCell: function (data) 
                    {
                        data.cell.styles.fillColor = [255, 255, 255];
                    }
                });
                
            })

            // delete unused empty page
            doc.deletePage(1)
            this.addWaterMark(doc)
            doc.save(this.report_root.title);
        },

        async fill_data(data)
        {
            this.table_headers = []

            let main_title = ''
            let second_title = ''

            if(data.daily_assignments.length > 1)
            {
                main_title      = data.daily_assignments.length + ' daily assignments'
                second_title    = data.daily_assignments.length + ' daily assignments'
            }
            else 
            {
                main_title      = `${data.daily_assignments[0].daily_assignment.description}`
                second_title    =  `${data.daily_assignments[0].daily_assignment.number_assigment} - ${data.daily_assignments[0].daily_assignment.description }`
            }

            this.report_root = {
                title: `Assignments Quick Report - Abbreviated View | ${main_title}`,
                name: `Abbreviated Associate Assignment`,
                daily_assignment_name: `${second_title}`,
                full_date: data.full_date,
                day_of_today: data.day_of_today

            }

            this.daily_assignments = data.daily_assignments
            this.title_page = this.report_root.title
            this.logo_corporation = data.logo_corporation

            this.json_pdf_fields.forEach( (item, i) => {
                if(i === 0)
                {
                    this.table_headers.push({
                        text: item.title,
                        align: "start",
                        value: item.dataKey,
                    })
                }
                else
                {
                    this.table_headers.push({
                        text: item.title,
                        value: item.dataKey,
                    })
                }
            })
            
            this.loader()    
        },

        async apiLocalMethod(see_all_rooms = false)
        {
            if(this.hasPermissions(['Report Read']))
            {
                let daily_assignment_ids = JSON.parse(this.daily_assignment_id)

                if(Array.isArray(daily_assignment_ids) && daily_assignment_ids.length)
                {
                    const form_data = {
                        standard_report_id: this.parent_id,
                        daily_assignment_id: daily_assignment_ids,
                        see_all_rooms
                    }

                    this.loader(true)

                    const response = await this.post('search_standard_reports', form_data)

                    if(response.status)
                    {
                        this.fill_data(response.data)
                    }
                    else
                    {
                        this.error_handling(response)
                        this.loader(false)
                    }
                }
                else
                {
                    window.location = '/reports'
                }
            }
        },

    },

    
    watch: 
    {
        async 'see_all_rooms'(val)
        {
            this.apiLocalMethod(val)
        }

    },

    async mounted()
    {
        await this.apiLocalMethod(false)
        this.breadcrumb.push({
            name: this.report_root.title,
            href: this.current_url,
            arrow: '',
        })
    },

}
</script>
